import React from 'react'


const GreenCheckCircle = ({ size = 22 }) => (
  <svg
    style={{ flexShrink: 0 }}
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 22 22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <linearGradient id="greenGradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#7DCA77" />
        <stop offset="100%" stopColor="#7DCA77" />
      </linearGradient>
    </defs>
    <circle cx="11" cy="11" r="11" fill="url(#greenGradient)" />
    <polyline
      points="12.5,6 12.5,13.8 9.77,13.82"
      stroke="#FFF"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
      transform="rotate(-315, 11.136, 9.907)"
    />
  </svg>
)
export default GreenCheckCircle
